<div class="footer"><slot/></div>

<style>
	.footer {
		font-size: .8em;
		color: grey;
		margin-top: 5px;
	}
</style>